import { atom, useAtom } from 'jotai'
import { useContext } from 'react'
import type { Meeting, TMeetingRoomView } from '@/types/meeting'
import { JotaiRootContext } from '../../providers/JotaiProvider'

// Atoms
// DON'T USE ANY OF THE NODES BELOW, ONLY USE THE HOOKS
const meetingAtom = atom<Meeting>(null as Meeting) // typecasting to Meeting is required since we don't have strictNullChecks=true in .tsconfig
const meetingRoomViewAtom = atom<TMeetingRoomView>('NOTES_ONLY')
const sendingMinutesRequestAtom = atom<boolean>(false)

// Utility Hooks
// EVERY HOOK EXPORTED SHOULD MAKE USE OF THE JOTAI ROOT CONTEXT TO GET THE STORE, THIS IS TO ENSURE THAT THE STATE IS SHARED GLOBALLY
export const useMeeting = () =>
    useAtom(meetingAtom, { store: useContext(JotaiRootContext) })

export const useMeetingRoomView = () =>
    useAtom(meetingRoomViewAtom, { store: useContext(JotaiRootContext) })

export const useSendingMinutesRequest = () =>
    useAtom(sendingMinutesRequestAtom, {
        store: useContext(JotaiRootContext),
    })
